<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gh98Qa/tc-custom/9781504052047.jpg?1708749521662" alt="This image is the cover for the book Novels of Madeleine L'Engle Volume One"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Novels of Madeleine L'Engle Volume One
      </h1>
      <p class="bookDescription body article font2">
        <b>From the National Book Award–winning author of <i>A Wrinkle in Time</i>, three poignant novels exploring the power of love, family, and secrets.</b><br/>  <br/><i>The Other Side of the Sun</i>: In this atmospheric novel of suspense set in the turn-of-the-century South, a nineteen-year-old British newlywed must stay with her American husband’s family on their South Carolina estate when he is called away on a diplomatic mission. She soon discovers her in-laws are not who they appear to be—as she stirs up dark secrets that were meant to remain buried.<br/>  <br/><i>A Live Coal in the Sea</i>: After her teenage granddaughter poses a troubling question, Dr. Camilla Dickinson must confront the painful history she’s long kept hidden as she relates a complex saga involving her beautiful, adulterous mother; her troubled son; and the difficult choices that have affected three generations.<br/>  <br/> “[A] haunting domestic drama.” —<i>Publishers Weekly</i><br/>  <br/><i>A Winter’s Love</i>: Emily Bowen’s marriage is hanging by a thread after hardships befall her family. During their sabbatical in Switzerland, a man from her past returns, offering the affection she craves, and Emily must decide if she’s willing to sacrifice the life she’s built for an unseen future.<br/>  <br/> “A convincing story of mixed loyalties and divided affections.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Madeleine L'Engle
      </h2>
      
      <p class="authorDescription body article">Madeleine L&rsquo;Engle (1918&ndash;2007) was an American author of more than sixty books, including novels for children and adults, poetry, and religious meditations. Her best-known work, <I>A Wrinkle in Time</I>, one of the most beloved young adult books of the twentieth century and a Newbery Medal winner, has sold more than fourteen million copies since its publication in 1962. Her other novels include <I>A Wind in the Door</I>,<I> A Swiftly Tilting Planet</I>, and <I>A Ring of Endless Light</I>. Born in New York City, L&rsquo;Engle graduated from Smith College and worked in theater, where she met her husband, actor Hugh Franklin. L&rsquo;Engle documented her marriage and family life in the four-book autobiographical series, the Crosswicks Journals. She also served as librarian and writer-in-residence at the Cathedral Church of Saint John the Divine in Manhattan for more than thirty years.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29375c97